// extracted by mini-css-extract-plugin
export default {"row":"GYcAZl1cDgWYkpulu8PR","title":"WFeO1aUPDgSsR2gX3o_y","pipe":"Anb7ZbFDXpTVcvpRPY1G","details":"eJnJYEDOcTYhtSoRYsxe","actions":"XYxQzWy_tQVY05l04nd4"};